import { isSettingsPath } from '@feature/settings/settings-navigation'
import { ChevronRight, Home } from 'lucide-react'
import { Link, useLocation, useMatches } from 'react-router'

interface BreadcrumbItem {
  label: string
  path: string
}

export function Breadcrumb() {
  const matches = useMatches()
  const { pathname } = useLocation()

  const breadcrumbs: BreadcrumbItem[] = matches
    .filter((match) => match.handle && (match.handle as { breadcrumb?: string }).breadcrumb)
    .map((match) => ({
      label: (match.handle as { breadcrumb: string }).breadcrumb,
      path: match.pathname,
    }))

  if (isSettingsPath(pathname)) {
    breadcrumbs.unshift({ label: 'Configurações', path: '/settings' })
  }

  if (pathname.startsWith('/calendar/') && !breadcrumbs.some((item) => item.path === '/calendar')) {
    breadcrumbs.unshift({ label: 'Calendário', path: '/calendar' })
  }

  if (breadcrumbs.length === 0) return null

  return (
    <nav
      aria-label="Caminho de navegação"
      className="flex min-w-0 items-center gap-1 overflow-hidden text-sm text-muted-foreground"
    >
      <Link
        to="/dashboard"
        aria-label="Início"
        className="hidden size-10 shrink-0 items-center justify-center transition-colors hover:text-foreground sm:inline-flex"
      >
        <Home className="h-4 w-4" />
      </Link>
      {breadcrumbs.map((breadcrumb, index) => (
        <div
          key={breadcrumb.path}
          className={`min-w-0 items-center gap-1 ${index === breadcrumbs.length - 1 ? 'flex' : 'hidden sm:flex'}`}
        >
          <ChevronRight aria-hidden="true" className="hidden h-4 w-4 sm:block" />
          {index === breadcrumbs.length - 1 ? (
            <span
              aria-current="page"
              className="truncate text-base font-semibold text-foreground sm:text-sm sm:font-medium"
            >
              {breadcrumb.label}
            </span>
          ) : (
            <Link
              to={breadcrumb.path}
              className="inline-flex min-h-10 items-center px-1 transition-colors hover:text-foreground"
            >
              {breadcrumb.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  )
}
